module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEUSURBVEhL7ZNBTsJgEIW7gD03qHoFNl6BdGNkxZYzcIm67caEExBXegt15TUUEmLYNJC/ftO+CFpb29ouMHzJy9CZN28Wf/BOOOeu0QvaoCcUaPR3CBsjl3yD1kiWZpDRIyRE7wp8pgyoM30/ytoMAm4s6BB6IaWv37GszSDg1YIOofdmM30mqbELlP8fD6jfGordo35rKHaP+q2h2K9o1viBtF68r3mnB9aZJTlTqzL80XztrtXKg+neHNRbtSrDTqTdB7XyMB9iiGWco3ONCsHjowgZO3Sp0c9gmKD0SB3Y2aKpYsrBGNQ5YuGUK62Xk61ksLikFD64zeT5RKNizMTSCi3Qr2+A/QLfne1UOnBkeN4HJB69e/iHiDgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bathtub/light/24.png
// module id = 1882
// module chunks = 2